module.exports = __webpack_public_path__ + "js/components/images/flag-philippines-3d7dd60c10866744cbbdbd8148984bfc.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/images/flag-philippines.png
// module id = 825
// module chunks = 31